import api from './api';

export interface RamoProv {
  codigoramoprov?: string;
  nombreramoprov?: string;
  ctactasxpg?: number;
  ctacompras?: number;
  estadoramoprov?: string;
}

const ramoProvService = {
  getRamosProv: async (): Promise<RamoProv[]> => {
    const resp = await api.get('/api/RamosProv');
    const data = resp.data;
    if (Array.isArray(data)) return data as RamoProv[];
    if (Array.isArray(data?.items)) return data.items as RamoProv[];
    return [];
  },
  
  getRamoProv: async (codigoramoprov: string): Promise<RamoProv | null> => {
    try {
      const resp = await api.get(`/api/RamosProv/${codigoramoprov}`);
      return resp.data as RamoProv;
    } catch (error) {
      console.error(`Error al obtener ramo prov ${codigoramoprov}:`, error);
      return null;
    }
  },
};

export default ramoProvService;

